import React from "react";

import { Box } from "@mui/material";
import MainHeader from "../../shared/MainHeader";

import PubCaseOnHoldTable from "../../components/PublicCaseHoldTable";

const PubcaseonHold = () => {
  return (
    <Box>
      <MainHeader headingText={"Public Cases on Hold"} />

      <PubCaseOnHoldTable />
    </Box>
  );
};

export default PubcaseonHold;
